import { ErrorBoundary } from 'react-error-boundary';
import { LoadingPage } from 'modules/app/components/pages/loading-page/LoadingPage';
import { PropsWithChildren, ReactNode, Suspense } from 'react';
import { SomethingWentWrong } from 'modules/app/components/pages/something-went-wrong/SomethingWentWrong';
import { useLocation } from 'react-router-dom';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';

interface RouteBoundaryProps {
  errorFallback?: JSX.Element;
  loadingFallback?: ReactNode;
}

export const RouteBoundary = ({
  errorFallback,
  loadingFallback,
  children
}: PropsWithChildren<RouteBoundaryProps>) => {
  const { reset } = useQueryErrorResetBoundary();
  const { pathname } = useLocation();
  return (
    <ErrorBoundary
      key={pathname}
      onReset={reset}
      fallback={errorFallback ?? <SomethingWentWrong />}
    >
      <Suspense fallback={loadingFallback ?? <LoadingPage />}>{children}</Suspense>
    </ErrorBoundary>
  );
};
